export default __webpack_public_path__ + "static/media/29.bb9f8c5a.png";